import { Box, Button, Checkbox, FormControlLabel, Radio, RadioGroup, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { T, TF } from "react-translator-component";
import GCBackButton from '../../../components/GreenCity/GCBackButton'
import { styles } from '../../styles';
import profile from "../../../assets/images/profile_img.png";
import Separator from '../../../components/Separator';
import SubmitButton from '../../../components/SubmitButton';
import { colors } from '../../../common/colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import MessageModal from '../../../components/Models/GreenCity/MessageModal';
import { ErrorMessageModal } from '../../../components/ErrorMessageModal';
import SeclectUser from './SeclectUser';
import appServices from '../../../services/app-services/appServices';
import { convertUserImage } from '../../../util/utils';

function GroupUserPayment() {
  const defaultImage = require("../../../assets/images/default.png");

  const groupInfo = useSelector((state: any) => state.gcGroup);
  const navigate = useNavigate();
  const [agree1, setAgree1] = useState<boolean>(false);
  const [agree2, setAgree2] = useState<boolean>(false);
  const [agree3, setAgree3] = useState<boolean>(false);
  const [feeType, setFeeType] = useState<string>('other_fee');
  const [amount, setAmount] = useState<number>(0)
  const [paymentDescription, setPaymentDescription] = useState<string>('')
  const [groupError, setGroupError] = useState<string>('')
  const [amountError, setAmountError] = useState<string>('')
  const [openMessageModal, setOpenMessageModal] = useState<boolean>(false);
  const [openErrorMessageModal, setOpenErrorMessageModal] = useState<boolean>(false);
  const [showGroups, setShowGroups] = useState<boolean>(false);
  const [showEvents, setShowEvents] = useState<boolean>(false);
  const [message, setMessage] = useState<string>('');
  const [accountInfo, setAccountInfo] = useState<any>();
  const [selectedUser, setSelectedUser] = useState<any>();

  useEffect(() => {
    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);

  const getGroupBalance = async () => {
    try {
      const res = await appServices.getGroupBalance(groupInfo?.id);
      setAccountInfo(res?.wallet_information?.balance?.money?.amount);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getGroupBalance();
  }, [groupInfo])

  const handleValidate = async (): Promise<boolean> => {
    if (!selectedUser?.id) {
      setGroupError(`${T("payee")}${T("error_select")}`);
      return false;
    }

    if (!amount) {
      setAmountError(`${T("payment_amount")}${T("error_enter")}`);
      return false;
    }

    return true
  }

  const handleSubmit = async (): Promise<boolean> => {
    const payment_type = feeType === 'monthly' || feeType === 'yearly' ? 'membership_fee' : feeType;

    const body = {
      "payer_type": "MemberGroup",
      "payer_id": groupInfo?.id,
      "payee_type": "User",
      "payee_id": selectedUser?.user_id ?? selectedUser?.id,
      "payment_type": payment_type,
      "billing_cycle": feeType,
      "amount": amount,
      "payment_details": paymentDescription,
    }

    try {
      const res = await appServices.createPayment(body);
      if (res?.success) {
        setMessage(T('payment_paid_to_group'));
        setOpenMessageModal(true)
        setTimeout(() => navigate(-1), 3000);
        return true
      } else {
        setMessage(`${T('payment_other_error')}`);
        setOpenMessageModal(true)
      }
    } catch (error: any) {
      const errorResponse = error.response.data.message
      setMessage(
        typeof errorResponse === "object" ?
        errorResponse.join("\n") :
        errorResponse ?? T("api_unknown_error")
      );
      setOpenErrorMessageModal(true)
    }

    return false
  };

  const handleChange = (e: any) => {
    setFeeType(e?.target.value);
  }

  const handleChangeAmount = (value: string) => {
    if (Number.isNaN(Number(value))) return
    setAmount(Number(value))

    if (Number(value) > 0) setAmountError('')
  }

  return (
    <div style={style.container}>
      <GCBackButton onClick={() => navigate(-1)} />

      <MessageModal
        onContinue={() => setOpenMessageModal(false) }
        message={message}
        open={openMessageModal}
        onClose={() => setOpenMessageModal(false) }
      />
      <ErrorMessageModal
        messages={[message]}
        open={openErrorMessageModal}
        onClose={() => setOpenErrorMessageModal(false) }
        showButton
        alignLeft={message.indexOf("\n") !== -1}
      />

      <Box style={{ padding: 16 }}>
        <Typography style={{ fontWeight: "700" }}>
          <img
            alt=""
            height={26}
            width={26}
            style={{ borderRadius: 13, marginRight: 10 }}
            src={groupInfo?.groupImage instanceof File ? URL.createObjectURL(groupInfo.groupImage) : defaultImage}
          />
          &nbsp;  {groupInfo?.groupName}
        </Typography>
      </Box>

      <div style={{ backgroundColor: colors.farm_gray15 }}>
        <Separator sx={{ marginTop: "10px", marginBottom: "10px" }} color="gray" />

        <Box style={{ padding: 16 }}>
          <Typography>{T("payment_address")}</Typography>
          <Separator sx={{ marginTop: "2px" }} color={colors.farm_green200} />

          {!showGroups && selectedUser?.id &&
            <Box style={style.marginTB}>
              <Typography style={{ fontWeight: "700" }}>
                <img
                  src={selectedUser.image !== null
                    ? convertUserImage(selectedUser.image)
                    : profile}
                  alt={"img"}
                  style={{
                    ...styles.farmProfileIcon,
                    height: 40,
                    width: 40,
                    margin: 0,
                  }}
                />
                &nbsp;{selectedUser?.nickname || selectedUser?.name}
              </Typography>
            </Box>
          }

          {showGroups && (
            <SeclectUser
              groupId={groupInfo?.id}
              owner={groupInfo.owner}
              onNext={(user) => { setSelectedUser(user); setShowGroups(false); setGroupError('') }}
            />
          )}

          {showEvents && (
            <SeclectUser
              eventId={groupInfo?.id}
              onNext={(user) => { setSelectedUser(user); setShowEvents(false); setGroupError('') }}
            />
          )}

          <div style={{ display: 'flex', justifyContent: 'center', padding: 4 }}>
            {!showGroups && (
              <Button
                sx={{
                  color: 'gray',
                  borderRadius: 20,
                  borderColor: colors.farm_blue200
                }}
                onClick={() => { setShowGroups(true); setShowEvents(false) }}
                variant="outlined"
              >
                {T("group_user_payment_select_group_member")}
              </Button>
            )}
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: 4
            }}
          >
            {!showEvents && (
              <Button
                sx={{ color: 'gray', borderRadius: 20, borderColor: colors.farm_blue200 }}
                onClick={() => { setShowEvents(true); setShowGroups(false) }}
                variant="outlined"
              >
                {T("group_user_payment_select_event_member")}
              </Button>
            )}
          </div>

          {(!showGroups || !showEvents) && <Typography style={{ color: 'red' }}>{groupError}</Typography>}
          <br />

          <Typography>{T("payment_type")}</Typography>
          <Separator sx={{ marginTop: "2px" }} color={colors.farm_green200} />

          <RadioGroup
            aria-labelledby="payment"
            defaultValue={feeType}
            name="fee"
            onChange={handleChange}
          >
            <FormControlLabel
              value="event_fee"
              control={<Radio />}
              label={T("group_user_payment_event_fee")}
            />
            <FormControlLabel
              value="joining_fee"
              control={<Radio />}
              label={T("membership_fee")}
            />
            <FormControlLabel
              value="monthly"
              control={<Radio />}
              label={T('monthly_fee')}
            />
            <FormControlLabel
              value="yearly"
              control={<Radio />}
              label={T('yearly_fee')}
            />
            <FormControlLabel
              value="other_fee"
              control={<Radio />}
              label={T('other')}
            />
          </RadioGroup>

          <Typography>{T('payment_amount')}</Typography>
          <Separator sx={{ marginTop: "2px" }} color={colors.farm_green200} />
          <br />

          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'baseline' }}>
            <TextField
              placeholder='0'
              type='text'
              value={amount}
              onChange={(e) => handleChangeAmount(e.target.value)}
              sx={{
                input: { textAlign: 'right' }
              }}
              id="outlined-basic"
              hiddenLabel
              variant="outlined"
            />
            {T('unit_yen')}
          </div>

          <Typography style={style.balance}>
            {TF(T("group_page_balance"), accountInfo ?? "")}
          </Typography>

          {!showGroups && <Typography style={{ color: 'red' }}>{amountError}</Typography>}
          <br />

          <Typography>{T("payment_details")}</Typography>
          <Separator sx={{ marginTop: "2px" }} color={colors.farm_green200} />
          <br></br>

          <TextField
            value={paymentDescription}
            onChange={(e) => { setPaymentDescription(e.target.value) }}
            multiline
            rows={2}
            hiddenLabel
            fullWidth
            variant="outlined"
          />
          <br />
          <br />

          <div style={{ padding: "15px 10px" }}>
            <Typography>{T("notice")}</Typography>
            <Separator sx={{ marginTop: "2px" }} color={colors.farm_green200} />

            <FormControlLabel
              control={<Checkbox checked={agree1} onChange={(e) => setAgree1(e.target.checked)} />}
              color="error"
              sx={{ color: false ? colors.farm_red600 : "black", marginTop: "30px" }}
              label={T('payment_checklist_1')}
            />
            <FormControlLabel
              control={<Checkbox checked={agree2} onChange={(e) => setAgree2(e.target.checked)} />}
              color="error"
              sx={{ color: false ? colors.farm_red600 : "black", marginTop: "20px" }}
              label={T('payment_checklist_2')}
            />
            <FormControlLabel
              control={<Checkbox checked={agree3} onChange={(e) => setAgree3(e.target.checked)} />}
              color="error"
              sx={{ color: false ? colors.farm_red600 : "black", marginTop: "20px" }}
              label={T('payment_checklist_3')}
            />
          </div>

          {/* Submit Button */}
          <SubmitButton
            disabled={!agree1 || !agree2 || !agree3}
            color="secondary"
            sx={style.submitButton}
            size={"large"}
            variant="outlined"
            endIcon={<FontAwesomeIcon style={{ position: "absolute", top: 0, right: 0, margin: "10px" }} icon={faChevronRight} />}
            validate={handleValidate}
            onSubmit={handleSubmit}
          >
            {T("payment_transfer_money")}
          </SubmitButton>
        </Box>
      </div>
    </div>
  )
}

export default GroupUserPayment

const style = {
  container: {
    paddingTop: 90,
  },
  marginTB: {
    marginTop: "10px",
    marginBottom: "10px"
  },
  balance: {
    fontSize: 12,
    color: colors.farm_gray200
  },
  submitButton: {
    width: "80%",
    alignSelf: "center",
    margin: "0 auto",
    display: "flex",
    borderRadius: 20,
    border: "2px solid",
    marginBottom: 8
  }
};